import styled from "@emotion/styled";
import theme from "../../styles/theme";

type IContent = {
  isDownload: boolean;
};

export const Content = styled.div<IContent>`
  max-width: ${theme.maxWidth};
  margin: 0 auto;

  ${theme.largerThan.md} {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 1rem;
  }

  ${theme.largerThan["2xl"]} {
    padding: 0;
  }
`;

export const SliceContent = styled.div<IContent>`
  padding: 0 ${theme.spacing[4]};

  ${theme.largerThan.md} {
    grid-column: ${(props) =>
      props.isDownload ? `span 7 / span 7` : `span 9 / span 9`};
    padding-right: 2rem;
  }

  ${theme.largerThan.xl} {
    padding: 0 ${theme.spacing[16]} 0 0;
  }
`;

export const SliceWrapper = styled.div``;

export const NarrowSliceWrapper = styled.div``;

export const FloatingAside = styled.div`
  padding: ${theme.spacing[4]};

  ${theme.largerThan.md} {
    padding: ${theme.spacing[8]} ${theme.spacing[4]} 0 0;
    grid-column: span 3 / span 3;
  }

  ${theme.largerThan.xl} {
    padding: ${theme.spacing[8]} 0;
  }
`;

export const Sticky = styled.aside`
  ${theme.largerThan.md} {
    position: sticky;
    top: 100px;
  }

  ${theme.largerThan.lg} {
    top: 148px;
  }
`;
